var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { styled } from "@material-ui/core/styles";
var StyledCharacterCountAdornment = styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ position: "absolute", top: theme.spacing(2), right: theme.spacing(4), color: theme.palette.text.secondary }, theme.typography.caption));
}, { name: "EuiCharacterCountAdornment" });
export var CharacterCountAdornment = React.forwardRef(function CharacterCountAdornment(_a, ref) {
    var value = _a.value, max = _a.max, props = __rest(_a, ["value", "max"]);
    return (React.createElement(StyledCharacterCountAdornment, __assign({}, props, { ref: ref }),
        value,
        "/",
        max));
});
//# sourceMappingURL=CharacterCountAdornment.js.map